import React from "react";
import * as S from "./JourneyTimeline.style";

const JourneyTimeline = ({ steps }) => {
  if (!steps || steps.length === 0) return null;

  return (
    <S.Container>
      <div className="timeline-banner">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className={`step ${step.status}`}>
              <div className="step-icon-wrapper">
                {step.status === "completed" && (
                   <div className="icon-circle completed"><i className="icon zaia-i-check-1" /></div>
                )}
                {step.status === "completed_warning" && (
                   <div className="icon-circle completed"><i className="icon zaia-i-check-1" /></div>
                )}
                {step.status === "current" && (
                   <div className="icon-circle current"><i className="icon zaia-icono-dots-horizontal" /></div>
                )}
              </div>
              <div className="step-content">
                <div className="title">{step.title}</div>
                <div className="date-row">
                  <span className="date">{step.date}</span>
                  {step.warning && (
                    <span className="warning">
                      <strong>{step.warning}</strong> <i className="icon zaia-i-alert" />
                    </span>
                  )}
                </div>
              </div>
            </div>

            {index < steps.length - 1 && (
              <div className="gap-line">
                <div className="line dashed" />
                <span className="gap-text">{step.gapText}</span>
                <div className="line dashed" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </S.Container>
  );
};

export default JourneyTimeline;
